export function iconByNameMenu(name) {
    switch (name) {
        case 'circle':
            return 'fa-solid fa-circle dark:text-gray-400 text-gray-700 text-[6px] pt-[1px]'

        default:
            return 'fa-solid fa-list-check dark:text-yellow-500 text-yellow-700'
    }
}

export function iconSelectByNameMenu(name) {
    switch (name) {
        default:
            return 'fa-solid fa-angle-right pt-[5px]'
    }
}

export function iconByRolNames(name) {
    switch (name) {
        case 'administrador':
            return 'fa fa-user-tie'
        case 'almacenes':
            return 'fa fa-store'
        case 'ventas':
            return 'fa fa-scale-unbalanced'
        case 'contabilidad':
            return 'fa fa-money-bill-trend-up'
        case 'tesoreria':
            return 'fa fa-sack-dollar'
        case 'pasante':
            return 'fa fa-user-nurse'
        default:
            return 'far fa-file-lines'
    }
}
